import React from 'react'
import InputField from 'admin/components/shared/InputField'
import DateField from 'admin/components/shared/DateField'

export default ({fromDate, toDate, fromAmount, toAmount, q, onSubmit}) => {
  const handleSearch = changes => {
    onSubmit({...changes, page: 1})
  }

  return (
    <form className='box is-radiusless is-shadowless has-background-filters'>
      <div className='field is-grouped'>
        <div className='control is-expanded'>
          <InputField
            type='search'
            name='q'
            label='Search'
            autoComplete='off'
            value={q}
            debounce={true}
            onChange={handleSearch}
          />
        </div>
        <div className='control'>
          <DateField name='fromDate' value={fromDate} onChange={handleSearch} />
        </div>
        <div className='control'>
          <DateField name='toDate' value={toDate} onChange={handleSearch} />
        </div>
        <div className='control'>
          <InputField name='fromAmount' value={fromAmount} onChange={handleSearch} />
        </div>
        <div className='control'>
          <InputField name='toAmount' value={toAmount} onChange={handleSearch} />
        </div>
      </div>
    </form>
  )
}
